{
    "api_keys": {
        "revoke": {
            "title": "Revoking API key",
            "message": "Revoking an API key will immediately cut off access for any applications using it.",
            "confirm": "Revoke",
            "cancel": "Cancel"
        }
    },
    "request": {
        "cancel": {
            "title": "Cancel request",
            "message": "Are you sure you want to cancel this request?",
            "confirm": "Yes, cancel",
            "cancel": "No"
        },
        "delete": {
            "title": "Delete request",
            "message": "Are you sure you want to delete this request?",
            "confirm": "Yes, delete",
            "cancel": "No"
        },
        "auto_approver": {
            "title": "Auto approval",
            "message": "This request will be auto-approved since the auto approver is select. Is this your intention?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "amounts_mismatch": {
            "title": "Amounts mismatch",
            "message": "The sum of net amounts or tax rates across all items does not match the total line. Should it be adjusted?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "datev_warning": {
            "title": "Warning",
            "message": "The invoice number of this expense contains characters that DATEV does not accept and which will be automatically be stripped when exporting.",
            "message_multiple": "At least one invoice number of these expenses contains characters that DATEV does not accept and which will be automatically be stripped when exporting.",
            "confirm": "Continue",
            "cancel": "Back"
        },
        "duplicate": {
            "invoice_file": {
                "title": "Duplicate Warning",
                "message_one": "This file was already uploaded for ",
                "message_two": " and might indicate a duplicate. Do you want to continue?",
                "confirm": "Continue",
                "cancel": "Back"
            },
            "invoice_number": {
                "title": "Duplicate Warning",
                "message_one": "This invoice number matches with ",
                "message_two": " and might indicate a duplicate. Do you want to continue?",
                "confirm": "Continue",
                "cancel": "Back"
            }
        },
        "performance_date_out_of_range": {
            "title_date": "Unusual performance date",
            "title_period": "Unusual performance period",
            "message_date_past": "The performance date is more than 3 years in the past. Do you want to continue?",
            "message_date_future": "The performance date is more than 3 years in the future. Do you want to continue?",
            "message_period_past": "The performance period is more than 3 years in the past. Do you want to continue?",
            "message_period_future": "The performance period is more than 3 years in the future. Do you want to continue?",
            "confirm": "Continue",
            "cancel": "Back"
        },
        "status_advancement": {
            "title": "Status advancement through export",
            "message_one": "Please define, if the status of the exported requests that are in status “paid” should be advanced to status “processed”. Status advancement applies only to DATEV and CSV exports, not to invoices or All formats export.",
            "message_two": "Advance the status of selected requests in paid status.",
            "confirm": "Export",
            "cancel": "Cancel"
        },
        "reset_status": {
            "title": "Warning",
            "message": {
                "pending": "If you reset this request, the approval process will be reset and all approvals done on it will be lost. Are you sure you want to revert the status of this request?",
                "discount_applied": "This request has discount applied. The discount will be removed in the process. Are you sure you want to revert the status of this request?",
                "default": "Are you sure you want to revert the status of this request?"
            },
            "confirm": "Yes",
            "cancel": "No"
        },
        "reset_status_folder": {
            "title": "Warning",
            "message": "Are you sure you want to revert the status of this folder?",
            "pending_request_message": "If you reset this folder, the approval process will be reset and all approvals done on it will be lost. Are you sure you want to revert the status of this folder?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "submit_folder_with_different_currencies": {
            "title": "Please wait a moment -  Folder contains different currencies",
            "message": "Please hold on while we recalculate the total amount of this folder based on today's exchange rates. Once done, you might need to resubmit the folder.",
            "confirm": "Understood"
        },
        "restore": {
            "title": "Warning",
            "message": "Are you sure you want to restore this request?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "tax_mismatch": {
            "title": "Tax mismatch",
            "message": "The tax rate across the invoice splits doesn't match this request's total tax amount. Should it be adjusted?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "queued_export": {
            "title": "Export queued",
            "message": "The export was queued and will be processed within the next couple of minutes.",
            "confirm": "Ok"
        },
        "per_diem_less_than_8h": {
            "title": "No per diem reimbursement",
            "message": "Your absence was 8 hours or less, therefore per diem rates do not apply and cannot be reimbursed.",
            "confirm": "Ok"
        },
        "admin_not_own_approval": {
            "title": "Warning",
            "message": "You are about to approve this expense for {{name}}. Are you sure you want to continue?",
            "folder_approval_message": "You are about to approve this folder for {{name}}. Are you sure you want to continue?",
            "purchase_order_approval_message": "You are about to approve this purchase order for {{name}}. Are you sure you want to continue?",
            "confirm": "Approve",
            "cancel": "Cancel"
        },
        "detach": {
            "title": "Detach request from folder",
            "message": "Are you sure you want to detach this request from the folder? If you detach it, it might be subject to another approval process.",
            "confirm": "Yes, remove",
            "cancel": "Cancel"
        },
        "delete_folder": {
            "title": "Delete folder",
            "message": "Are you sure you want to delete this folder? All contained requests will be ungrouped, only the folder will be deleted.",
            "confirm": "Yes, delete",
            "cancel": "Cancel"
        },
        "archive_folder": {
            "title": "Archive folder",
            "message": "Are you sure you want to archive this folder? ",
            "extra": "Please choose the elements you want to archive:",
            "all": "Are you sure you want to archive this folder including the requests inside it?",
            "confirm": "Archive",
            "select": {
                "folder_only": "Only folder",
                "all": "Folder & requests"
            },
            "cancel": "Cancel"
        },
        "unarchive_folder": {
            "title": "Unarchive folder",
            "message": "Are you sure you want to unarchive this folder? ",
            "extra": "Please choose the elements you want to unarchive:",
            "all": "Are you sure you want to unarchive this folder including the requests inside it?",
            "confirm": "Unarchive",
            "select": {
                "folder_only": "Only folder",
                "all": "Folder & requests"
            },
            "cancel": "Cancel"
        },
        "reject_folder": {
            "title": "Reject this folder",
            "message": "The folder will be set to status rejected. All included requests will be ungrouped from the folder and assigned to the dashboard according to their status. For questions or small remarks, we recommend using comments. Are you sure you would like to reject?",
            "confirm": "Reject",
            "cancel": "Cancel"
        },
        "gobd_invoice_compliance": {
            "flagging": {
                "title": "GoBD-compliant invoice creation",
                "message": "Are you sure you want to create a GoBD-compliant invoice with the provided information? Once the invoice is marked as \"GoBD-compliant\", it will become uneditable and all fields will be locked.",
                "missing_iban": "Please note: The vendor's IBAN is missing. If you confirm, the payment and the SEPA XML download will not be possible. Please add the vendor's IBAN in the <0>vendor master data</0> and synchronize the changes beforehand.",
                "confirm": "Confirm",
                "cancel": "Cancel"
            }
        },
        "archive": {
            "title": "Archive request",
            "title_plural": "Archive requests",
            "message": "Are you sure you want to archive this request? \n\n While archived, you can no longer make any changes to the request.",
            "message_plural": "Are you sure you want to archive these requests? \n\n While archived, you can no longer make any changes to the requests.",
            "confirm": "Yes, archive",
            "cancel": "No"
        }
    },
    "subscription": {
        "delete": {
            "title": "Delete subscription",
            "message": "Are you sure you want to delete this subscription? Thereby, also all requests related to this subscription will be deleted.",
            "message_with_card": "Additionally, the connected card will be closed automatically.",
            "confirm": "Yes, delete",
            "cancel": "No"
        },
        "item_split_replaces_net_split": {
            "title": "Item split replaces net split",
            "message": "Are you sure you want to update this subscription? You have added items to this subscription. Saving will replace the previous <0>net split (%)</0>. All future recurring expenses will then use an <0>item-based split</0> instead of a <0>net-based split</0>.",
            "confirm": "Yes, update",
            "cancel": "No"
        }
    },
    "transaction": {
        "delete": {
            "title": "Delete transaction",
            "message": "Are you sure you want to delete this transaction?",
            "confirm": "Yes, delete",
            "cancel": "No"
        },
        "bulk_delete": {
            "title": "Delete transactions",
            "message": "Are you sure you want to delete these transactions?"
        }
    },
    "vendor": {
        "delete": {
            "title": "Delete vendor",
            "message": "Are you sure you want to delete this vendor?",
            "confirm": "Yes, delete",
            "cancel": "No"
        },
        "restore": {
            "title": "Restore vendor",
            "name_message": "A vendor with this name existed in the past. Do you want to restore it?",
            "creditor_number_message": "A vendor with this creditor number existed in the past. Do you want to restore it?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "incompatible_creditor_number": {
            "title": "Creditor number not compatible with DATEV",
            "message": "The creditor number is not compatible with DATEV due to the following reason: {{reason}} Do you wish to proceed?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "duplicate": {
            "title": "This vendor is potentially a duplicate of existing vendors",
            "message": "Similar existing vendors have been found. Please check carefully whether the new provider may already exist in the system.\n \n Below you find an overview of potential duplicate vendors.",
            "cancel": "Cancel"
        }
    },
    "employee": {
        "delete": {
            "title": "Delete employee",
            "message": "All approval processes this user is part of will be recalculated and reset. Are you sure you want to delete this employee?",
            "replacement_label": "Please select an employee to replace the employee to be deleted in workflows.",
            "confirm": "Yes, delete",
            "cancel": "No"
        },
        "demote": {
            "title": "Demote employee",
            "message": "All approval processes this user is part of will be recalculated and reset. Are you sure you want to demote this employee?",
            "replacement_label": "Please select an employee to replace the employee to be demoted in workflows.",
            "confirm": "Yes, demote",
            "cancel": "No"
        },
        "remove_substitute": {
            "title": "Are you sure?",
            "message": "This user is currently set as a substitute approver. If you continue, they will no longer be able to approve on behalf of the main approver. The main approver will be notified to choose a new substitute.",
            "confirm": "Continue",
            "cancel": "Cancel"
        },
        "restore": {
            "title": "Restore employee",
            "message": "An employee with this email address already existed in the past. Do you want to restore it?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "cannot_be_deleted_because_is_fallback_approver": {
            "title": "Role of this user cannot be deleted",
            "message": "This user is currently set up as this company's workfow fallback approver and therefore, cannot be deleted. Please select another user as workflow fallback approver first.",
            "confirm": "Ok, got it"
        },
        "enroll_without_date_of_birth": {
            "title": "No date of birth stored",
            "message": "{{name}} can be added to the card program now, but no card can be issued to them until a date of birth is stored. Only they can enter it, and they will be asked for it before they can carry on in finway the next time they log in.",
            "confirm": "Add anyway",
            "cancel": "Cancel"
        }
    },
    "cost_center": {
        "delete": {
            "title": "Delete cost center 1",
            "message": "Are you sure you want to delete this cost center 1?",
            "message_shared_note": "Attention: All shared users will loose access.",
            "confirm": "Yes, delete",
            "cancel": "No"
        },
        "restore": {
            "title": "Restore cost center 1",
            "message": "A cost center 1 with this ID already existed in the past. Do you want to restore it?",
            "confirm": "Yes",
            "cancel": "No",
            "change_responsible_user": "{{newUserName}} will be set as the responsible user of the cost center to be restored because the original responsible employee, {{originalUserName}} has not sufficient role rights to be so. Do you want to proceed?"
        },
        "budget_period_change": {
            "title": "Change cost center budget period",
            "message": "Are you sure you want to change budget period? If you proceed all alternative budgets you have set up for this cost center will be lost.",
            "confirm": "Yes, change period",
            "cancel": "No"
        }
    },
    "comment": {
        "delete": {
            "title": "Delete comment",
            "message": "Are you sure you want to delete this comment?",
            "confirm": "Yes, delete",
            "cancel": "No"
        }
    },
    "file": {
        "delete_from_server": {
            "title": "Warning",
            "message": "Are you sure you want to permanently delete this file?",
            "confirm": "Yes, delete",
            "cancel": "Cancel"
        }
    },
    "payment_subscription": {
        "reactivate": {
            "title": "Reactivate payment subscription",
            "message": "Are you sure you want to re-activate your payment subscription?",
            "confirm": "Reactivate",
            "cancel": "Cancel"
        },
        "cancel": {
            "title": "Cancel payment subscription",
            "message": "Are you sure you want to cancel your payment subscription?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "error": {
            "title": "Payment failed",
            "message": "Your payment failed. Please try with a different card or remove your payment data.",
            "cancel": "Remove",
            "confirm": "Try a different card"
        },
        "delete": {
            "title": "Delete payment subscription data",
            "message": "Are you sure you want to delete your payment subscription data?",
            "cancel": "No",
            "confirm": "Yes"
        }
    },
    "banking": {
        "delete": {
            "title": "Delete bank connection",
            "message": "Are you sure you want to delete this bank connection?",
            "warning": "Warning: Categorization will be disabled for transactions imported from this connection.",
            "confirm": "Yes",
            "cancel": "No"
        },
        "account": {
            "delete": {
                "title": "Delete bank account",
                "message": "Are you sure you want to delete this account?",
                "confirm": "Yes",
                "cancel": "No"
            }
        },
        "force_reset_payment_status": {
            "title": "Start a New Payment Attempt?",
            "message_pending": "Your payment has been pending for {{days}} days.",
            "message_double_payment": "Starting a new payment attempt may result in a duplicate charge if the original payment is completed later by your bank or payment provider. Before continuing, please check your online banking or payment activity to confirm that the original payment has not already been processed.",
            "message_risk": "By proceeding, you acknowledge and accept that restarting the payment is done at your own risk.",
            "message_confirm": "Type {{keyword}} to continue.",
            "placeholder": "RESTART",
            "keyword": "RESTART",
            "mismatch_title": "Confirmation required",
            "mismatch_message": "Please enter the confirmation word exactly as shown.",
            "confirm": "Continue",
            "cancel": "Cancel"
        }
    },
    "cards": {
        "suspend": {
            "title": "Suspend card",
            "message": "Are you sure you want to suspend this card? This will remove all funds from the card.",
            "confirm": "Yes",
            "cancel": "No"
        },
        "close": {
            "title": "Close card",
            "message": "Are you sure you want to irreversibly close this card? This will remove all funds from the card.",
            "confirm": "Yes",
            "cancel": "No"
        },
        "report_stolen": {
            "title": "Report card as stolen",
            "message": "Are you sure you want to report this card as stolen? This will remove all funds from the card and irreversibly terminate it.",
            "confirm": "Yes",
            "cancel": "No"
        },
        "report_lost": {
            "title": "Report card as lost",
            "message": "Are you sure you want to report this card as lost? This will remove all funds from the card and irreversibly terminate it.",
            "confirm": "Yes",
            "cancel": "No"
        },
        "kyb_start": {
            "title": "KYB warning",
            "message_start": "Dear Customer, you are about to start the KYB process for the finway cards. Please verify whether you are the right person for this - should the need to change arise later on, it requires a vast amount of effort and you may incur costs.",
            "message_point_1": "You have read and understood the KYB process document, provided in the help center",
            "message_point_2": "You either have registered procura rights, have signatory power or have another power of attorney signed by someone with signatory rights",
            "message_point_3": "You have the documents outlined in the KYB process document at hand",
            "message_point_4": "You have synched with your customer success manager beforehand",
            "message_end": "If you've checked all the above, please click continue.",
            "confirm": "Continue",
            "cancel": "Cancel"
        },
        "limit_update": {
            "title": "Adjustment of card limit",
            "message": "Would you like to also adjust the limit of the attached card to the new request amount?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "physical_card_delivery": {
            "title": "Physical card delivery",
            "message": "Has your physical card already been delivered? You should only activate a card after you received it.",
            "confirm": "Yes",
            "cancel": "No"
        },
        "payment_flow_info_reset": {
            "title": "Payment status reset",
            "message": "This subscription has a payment status set. By issuing a card for it, this status will be unset for the subscription and all it's future recurring expenses. Are you sure you want to continue?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "payment_flow_info_reporting_only_on_creation": {
            "title": "Payment status \"reporting only\"",
            "message": "Are you sure that you want to submit this request? The payment status “reporting only” cannot be changed anymore. The export to accounting tools, e.g. to DUO, will not be possible.",
            "confirm": "Submit request",
            "cancel": "Cancel"
        },
        "payment_flow_info_already_paid_on_review": {
            "title": "Payment status \"already paid\"",
            "message": "Are you sure that you want to mark this request as reviewed? When payment status \"already paid\" is selected, the payment step will be skipped.",
            "confirm": "Submit request",
            "cancel": "Cancel"
        },
        "payment_flow_info_already_approved_and_paid_on_review": {
            "title": "Payment status \"approved & paid\"",
            "message": "Are you sure that you want to mark this request as reviewed? When payment status \"approved & paid\" is selected, the payment step will be skipped.",
            "confirm": "Submit request",
            "cancel": "Cancel"
        },
        "payment_flow_info_on_bulk_review": {
            "title": "Payment status set",
            "message": "At least one of these requests has a payment status set. Are you sure you want to review all of them? The payment step might be skipped for requests with a payment status set.",
            "confirm": "Submit request",
            "cancel": "Cancel"
        },
        "non_euro_wallet": {
            "title": "Non-Euro Wallet",
            "message": "Are you sure that you do not want Euro as the base currency for your finway wallet and cards? This cannot be changed afterwards.",
            "confirm": "Yes",
            "cancel": "No"
        }
    },
    "workflow": {
        "delete": {
            "title": "Delete workflow",
            "message": "All approval processes that depend on this workflow and have not yet been started will have their workflows recalculated. Are you sure you want to delete this workflow?",
            "confirm": "Yes",
            "cancel": "No"
        }
    },
    "approval_process": {
        "recalculate_in_progress": {
            "title": "Recalculate approval processes in progress",
            "message": "This request approval process will change. The approval process and all previous approvals will be reset.",
            "current_workflow_title": "Current workflow",
            "updated_workflow_title": "Updated workflow",
            "ocr_title": "Apply OCR changes to request",
            "ocr_message": "This expense's approval process will change after applying OCR changes and all previous approved processes will be reset.",
            "folder_amount_message": "This expense's folder approval process and all previous approvals will be reset.",
            "detached_expense_message": "This expense's approval process will change after being detached from the folder and all previous approvals will be reset.",
            "continue_process": "Are you sure you want to continue?",
            "update_or_delete_workflow_message": "All approval processes depending on this workflow will have their workflows recalculated and all previous approvals will be reset. Are you sure you want to continue?"
        }
    },
    "company": {
        "delete": {
            "title": "Are you sure you want to delete this company?",
            "message": "The company will be moved to the “Deleted” section. Access will be removed and the DUO integration will be disconnected. If restored, the data will return, but DUO must be set up again.",
            "confirm": "Yes, delete",
            "cancel": "No"
        },
        "restore": {
            "title": "Are you sure you want to restore this company?",
            "message": "All the data related to this company will be restored.",
            "confirm": "Yes, restore",
            "cancel": "No"
        }
    },
    "export": {
        "duplicate_datev_online": {
            "title": "Duplicate DUO export",
            "message_singular": "  has already been exported to DUO before. Are you sure you want to export it again?",
            "message_plural": "  have already been exported to DUO before. Are you sure you want to export them again?",
            "confirm": "Yes",
            "cancel": "No"
        }
    },
    "liquidity": {
        "delete_scenario": {
            "title": "Are you sure you want to delete this scenario?",
            "message": "All the data related to this scenario will be deleted.",
            "confirm": "Yes, delete",
            "cancel": "No"
        },
        "delete_forecast_rule": {
            "title": "Delete forecast rule",
            "message": "Are you sure you want to delete this forecast rule?",
            "confirm": "Yes",
            "cancel": "No"
        }
    },
    "datev": {
        "bu_code": {
            "title": "DATEV incompatible BU codes",
            "message": "DATEV only allows up to 4 numeric digits with no leading zero. Do you still want to continue?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "expense_account_code": {
            "title": "DATEV incompatible account code(s)",
            "message": "DATEV only allows up to 8 numeric digits with no leading zero. Do you still want to continue?",
            "confirm": "Yes",
            "cancel": "No"
        }
    },
    "transaction_category": {
        "delete": {
            "title": "Delete transaction category",
            "message": "Are you sure you want to delete this transaction category?",
            "confirm": "Yes, delete",
            "cancel": "No"
        }
    },
    "expenseTag": {
        "delete": {
            "title": "Deleting a custom tag",
            "message": "Are you sure you want to delete tag {{expenseTagName}}? It is used in {{count}} request.",
            "message_other": "Are you sure you want to delete tag {{expenseTagName}}? It is used in {{count}} requests.",
            "confirm": "Yes, delete",
            "cancel": "Cancel"
        }
    },
    "direct_debit_agreement": {
        "title": "Recurring direct debit agreement",
        "message": "If you choose to pay by direct debit, we will apply the SEPA direct debit procedure. As soon as you have completed and submitted the direct debit mandate, we will assign a mandate reference number. This authorizes us to debit the corresponding amount from your selected bank account on a recurring basis. For the first invoice, we will send you an advance notice for recurring payment, giving you 14 days' notice of the direct debit. For all subsequent invoices, no advance notice will be given. We will then initiate the direct debit in accordance with the agreements made in the advance notice, or 1 working day after the invoice is issued.\n\nIn case of a return debit note (e.g. due to lack of required coverage of the account, due to expiration of the account, unauthorized objection of the account holder or incorrect entry of the account data) you authorize finway GmbH to submit the debit note for the respective due payment obligation a second time. In this case you are obligated to bear the costs resulting from the return debit note. Further claims are reserved.\n\nIf you agree to this direct debit agreement, you authorize finway GmbH to obtain recurring payments from your account by direct debit. At the same time, we instruct our credit institution to execute the direct debits drawn on our account by finway GmbH.\n\nNote: We can demand reimbursement of the debited contract within eight weeks, beginning with the debit date. In this case, the conditions agreed with our credit institution apply. "
    },
    "delete_role": {
        "title": "Deleting role",
        "message": "Deleting a role will automatically change the roles & rights of its users to an Employee role.",
        "confirm": "Delete",
        "cancel": "Cancel"
    },
    "csv_settings": {
        "delete": {
            "title": "Delete selected CSV template ",
            "message": "Are you sure you want to delete the selected CSV template. You cannot restore it - only recreate it.",
            "confirm": "Delete",
            "cancel": "Cancel"
        }
    },
    "key": "item",
    "key_plural": "items",
    "keyWithCount_one": "{{count}} item",
    "keyWithCount_other": "{{count}} items",
    "expense_account_settings": {
        "bulk_delete": {
            "title": "Delete expense account(s)",
            "confirm": "Yes, delete",
            "cancel": "No",
            "message": "Are you sure that you want to delete this expense account?",
            "message_other": "Are you sure that you want to delete these {{count}} selected expense accounts?"
        }
    },
    "cost_center_2_settings": {
        "bulk_delete": {
            "title": "Delete Cost Center 2",
            "confirm": "Yes, delete",
            "cancel": "No",
            "message": "Are you sure that you want to delete this cost center 2?",
            "message_other": "Are you sure that you want to delete these {{count}} selected cost center 2s?"
        }
    },
    "trip_folder": {
        "delete": {
            "title": "Delete folder",
            "message": "Are you sure you want to delete this folder? All contained requests will be ungrouped, only the folder will be deleted.",
            "cancel": "Cancel",
            "confirm": "Yes, delete"
        }
    },
    "edit_right_restricted": {
        "title": "Role update restricted",
        "message": "One or more right updates generates conflicts, please solve the conflicts before continuing.",
        "confirm": "Cancel",
        "approval_right": {
            "title": "Function: Approval. Editing rights (Requests)",
            "message": "One or more right updates can not be removed from the following users because they are approvers of expenses and/or workflows:",
            "expenses": "Expense(s) number {{list}} in company {{companyName}}.",
            "workflows": "Workflow(s) with order {{list}} in company {{companyName}}."
        }
    },
    "session_conflict": {
        "title": "You've been logged out!",
        "message": "You have been automatically logged out because a login was detected on another device. If this was not you, please secure your account by changing your password. If this was you, you can disregard this message.",
        "action": "Okay"
    },
    "discount": {
        "apply_expired": {
            "title": "Time window for cash discount expired",
            "message": "The time window for the cash discount deduction has expired. By confirming, the cash discount deduction will still be added to this request.",
            "confirm": "Confirm",
            "cancel": "Cancel"
        }
    },
    "unsaved_changes": {
        "title": "Unsaved changes",
        "message": "By leaving you will loose your input in the modal form. Do you want to continue?",
        "confirm": "Discard changes",
        "cancel": "Keep editing"
    },
    "no_request_sync": {
        "title": "No synchronization selected",
        "message": "Do you want to synchronize these changes to the requests that use this resource?",
        "cancel": "No, do not synchronize",
        "confirm": "Yes, synchronize"
    },
    "reset_demo_data": {
        "title": "Reset demo data",
        "message": "Are you sure you want to reset the demo data? All your changes and settings will be reset.",
        "cancel": "No",
        "confirm": "Yes, reset"
    },
    "inbox_invoice": {
        "assign_colleague": {
            "title": "Do you want to assign this document to {{name}}?",
            "message": "By assigning this document to {{name}}, this person gets access to the file in the inbox and can process it.",
            "confirm": "Confirm",
            "cancel": "Cancel"
        },
        "unassign_colleague": {
            "title": "Do you want to unassign {{name}} from this document?",
            "message": "If you unassign {{name}} from this document, then the document access for this person will be revoked.",
            "confirm": "Confirm",
            "cancel": "Cancel"
        }
    },
    "tfa": {
        "reset": {
            "title": "Reset login presets",
            "message": "Are you sure you want to reset the 2FA for this employee?",
            "cancel": "No",
            "confirm": "Yes, reset"
        }
    },
    "purchase_order": {
        "delete": {
            "title": "Delete purchase order",
            "message": "Are you sure you want to delete this purchase order? This will also permanently remove all links to related invoices and delivery notes.",
            "cancel": "No",
            "confirm": "Yes, delete"
        },
        "link_mismatching_invoice": {
            "title": "Warning",
            "message": "The order number on the invoice ({{ poNumberOnInvoice }}) does not match the order number on the purchase order ({{ poNumber }}).",
            "cancel": "Cancel",
            "confirm": "Link anyway"
        },
        "link_mismatching_delivery_note": {
            "title": "Warning",
            "message": "The order number on the delivery note ({{ poNumberOnDeliveryNote }}) does not seem to match the order number on the purchase order ({{ poNumber }}).",
            "cancel": "Cancel",
            "confirm": "Link anyway"
        },
        "reopen_from_completed": {
            "title": "Warning",
            "message": "Are you sure you want to revert the status of this purchase order? It will be set back to \"Fulfillment,\" allowing you to link it again.",
            "cancel": "Cancel",
            "confirm": "Reset status"
        },
        "complete": {
            "title": "Warning: Order not yet linked",
            "message": "This order has not yet been linked to an invoice request. <0>If you complete the order now, the link can no longer be established.</0>",
            "cancel": "No",
            "confirm": "Complete anyway"
        },
        "card_po_complete": {
            "title": "Warning: Order not yet linked",
            "message": "This order has not yet been linked to the corresponding card request. Once the transaction has been created, finway will automatically establish the connection. <0>If you complete the order now, the link can no longer be established and the card will be closed.</0>",
            "cancel": "No",
            "confirm": "Complete anyway"
        }
    },
    "opos": {
        "clear_item": {
            "title": "Clear item",
            "message": "Do you really want to clear this item from the open items list? The entry will be removed from the list, but will remain in the system.",
            "confirm": "Yes",
            "cancel": "No"
        },
        "retrieve_item": {
            "title": "Retrieve Item",
            "message": "Are you sure you want to include this item again in the open items list?",
            "confirm": "Yes",
            "cancel": "No"
        },
        "retrieve_items": {
            "title": "Retrieve Items",
            "message": "Are you sure you want to include these items again in the open items list?",
            "confirm": "Yes",
            "cancel": "No"
        }
    },
    "self_issued_receipt": {
        "enable": {
            "title": "Generate a self-issued receipt",
            "bullet_1": "A self-issued receipt serves as a substitute for an invoice or receipt that does not exist or is no longer available.",
            "bullet_2": "This should be considered a last resort and should only be used if there is no other way to obtain the original invoice or a copy.",
            "bullet_3": "The reason for and nature of the costs must be specified.",
            "bullet_4": "A self-issued receipt should not exceed the amount of €250.",
            "bullet_5": "Input tax cannot be deducted for a self-issued receipt."
        },
        "discard": {
            "title": "Great! Your receipt is available?",
            "message": "Disabling self-issued receipt means you can now provide the original receipt and no longer need the self-issued receipt created by the system.",
            "confirm": "Discard self-issued receipt",
            "cancel": "Cancel"
        }
    },
    "vendor_payments": {
        "cancel": {
            "title": "Cancel vendor payment {{reference}}?",
            "message": "Its documents are released and can be paid or exported again. A transfer you already made in your online banking is not reverted.",
            "confirm": "Cancel vendor payment",
            "cancel": "Keep"
        }
    }
}
